import type { TransactionCurrency } from '@contracts/payment/Currency';
import { Button } from '@src/common/components/button/Button';
import { Stack } from '@src/common/components/Stack';
import { css } from '@src/common/styles/Styles';
import { MakePaymentModal } from '@src/orders/components/payment/MakePaymentModal';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const MakePaymentButton = ({
  orderId,
  clientId,
  onPaymentSuccess,
  onPaymentError,
  blockedCurrency,
  disabled,
  maxBillable,
}: {
  orderId: string;
  clientId: string;
  onPaymentSuccess: () => void;
  onPaymentError: () => void;
  blockedCurrency?: TransactionCurrency;
  disabled?: boolean;
  maxBillable: number;
}) => {
  const { t } = useTranslation();

  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
  const openPaymentModal = () => setIsPaymentModalOpen(true);
  const closePaymentModal = () => setIsPaymentModalOpen(false);

  return (
    <>
      <Stack width="fit-content" alignSelf="flex-end">
        <Button
          className={buttonStyle}
          variant="contained"
          onClick={openPaymentModal}
          disabled={disabled}
        >
          {t('makePayment.title')}
        </Button>
      </Stack>

      <MakePaymentModal
        clientId={clientId}
        orderId={orderId}
        isOpen={isPaymentModalOpen}
        onClose={closePaymentModal}
        onPaymentSuccess={onPaymentSuccess}
        onPaymentError={onPaymentError}
        blockedCurrency={blockedCurrency}
        maxBillable={maxBillable}
      />
    </>
  );
};

const buttonStyle = css({
  borderRadius: '100px',
});
